const KEY = "vegifyit_creation_event_context";

export const setCreationEventContext = (eventId, returnTo) =>
  sessionStorage.setItem(KEY, JSON.stringify({ eventId, returnTo }));

export const getCreationEventContext = () =>
  JSON.parse(sessionStorage.getItem(KEY) || "null");

export const clearCreationEventContext = () =>
  sessionStorage.removeItem(KEY);
